<script setup lang="ts">
import { useRoute } from 'vue-router';

const route = useRoute();
</script>

<template>
  <main class="placeholder">
    <h1>EMSL Portal (Vue 3 port — scaffolding)</h1>
    <p>
      This route is not yet ported. Current route name:
      <code>{{ String(route.name ?? '(unnamed)') }}</code>
    </p>
  </main>
</template>

<style scoped>
.placeholder {
  max-width: 60rem;
  margin: 4rem auto;
  padding: 0 1.5rem;
  font-family: system-ui, sans-serif;
}
</style>
